import { render, staticRenderFns } from "./re-optimize.vue?vue&type=template&id=3c467791&"
import script from "./re-optimize.vue?vue&type=script&lang=js&"
export * from "./re-optimize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports